import svg from "./molecule-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const MoleculeIcon = makeSvgIcon(svg);

export default MoleculeIcon;
